export default {
      id: "group-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.a60dffc6.svg#group",
      toString: function () {
        return this.url;
      }
    }